import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import dayjsImport from "./auth-service-tools36.js";
import { useDatesContext } from "./auth-service-tools577.js";
import { PickerControl } from "./auth-service-tools593.js";
import { getYearInTabOrder } from "./auth-service-tools596.js";
import { getYearsData } from "./auth-service-tools597.js";
import { isYearDisabled } from "./auth-service-tools598.js";
import classes from "./auth-service-tools599.js";
import { factory } from "./auth-service-tools248.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
const defaultProps = {
  yearsListFormat: "YYYY",
  withCellSpacing: true
};
const YearsList = factory((_props, ref) => {
  const props = useProps("YearsList", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    decade,
    yearsListFormat,
    locale,
    minDate,
    maxDate,
    getYearControlProps,
    __staticSelector,
    __getControlRef,
    __onControlKeyDown,
    __onControlClick,
    __onControlMouseEnter,
    __preventFocus,
    __stopPropagation,
    withCellSpacing,
    size,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "YearsList",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    rootSelector: "yearsList"
  });
  const ctx = useDatesContext();
  const years = getYearsData(decade);
  const yearInTabOrder = getYearInTabOrder(years, minDate, maxDate, getYearControlProps);
  const rows = years.map((yearsRow, rowIndex) => {
    const cells = yearsRow.map((year, cellIndex) => {
      const controlProps = getYearControlProps == null ? void 0 : getYearControlProps(year);
      const isYearInTabOrder = dayjsImport(year).isSame(yearInTabOrder, "year");
      return /* @__PURE__ */jsxRuntimeExports.jsx("td", { ...getStyles("yearsListCell"),
        "data-with-spacing": withCellSpacing || void 0,
        children: /* @__PURE__ */jsxRuntimeExports.jsx(PickerControl, { ...getStyles("yearsListControl"),
          size,
          unstyled,
          "data-mantine-stop-propagation": __stopPropagation || void 0,
          disabled: isYearDisabled(year, minDate, maxDate),
          ref: node => __getControlRef == null ? void 0 : __getControlRef(rowIndex, cellIndex, node),
          ...controlProps,
          onKeyDown: event => {
            var _a;

            (_a = controlProps == null ? void 0 : controlProps.onKeyDown) == null ? void 0 : _a.call(controlProps, event);
            __onControlKeyDown == null ? void 0 : __onControlKeyDown(event, {
              rowIndex,
              cellIndex,
              date: year
            });
          },
          onClick: event => {
            var _a;

            (_a = controlProps == null ? void 0 : controlProps.onClick) == null ? void 0 : _a.call(controlProps, event);
            __onControlClick == null ? void 0 : __onControlClick(event, year);
          },
          onMouseEnter: event => {
            var _a;

            (_a = controlProps == null ? void 0 : controlProps.onMouseEnter) == null ? void 0 : _a.call(controlProps, event);
            __onControlMouseEnter == null ? void 0 : __onControlMouseEnter(event, year);
          },
          onMouseDown: event => {
            var _a;

            (_a = controlProps == null ? void 0 : controlProps.onMouseDown) == null ? void 0 : _a.call(controlProps, event);
            __preventFocus && event.preventDefault();
          },
          tabIndex: __preventFocus || !isYearInTabOrder ? -1 : 0,
          children: dayjsImport(year).locale(ctx.getLocale(locale)).format(yearsListFormat)
        })
      }, cellIndex);
    });
    return /* @__PURE__ */jsxRuntimeExports.jsx("tr", { ...getStyles("yearsListRow"),
      children: cells
    }, rowIndex);
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
    component: "table",
    ref,
    size,
    ...getStyles("yearsList"),
    ...others,
    children: /* @__PURE__ */jsxRuntimeExports.jsx("tbody", {
      children: rows
    })
  });
});
YearsList.classes = classes;
YearsList.displayName = "@mantine/dates/YearsList";
export { YearsList };